import { User } from '../models/user.model';
import { GROUP_CONSTANTS } from '../shared.constants/all-constants';

const STANDARD_LIST_PAGE_KEY = 'lastPage2';
const STANDARD_LIST_USER_KEY = 'User';
const PERSONAL_STANDARD_LIST_ROUTE = '/dashboard/standards';
const ROLE_NOT_FOUND = -1;
const PREVIOUS_ROUTE_KEY = 'prevRoute';
const NEXT_ROUTE_KEY = 'nextRoute';
const STANDARD_LIST_ROUTE = '/dashboard/operating-standards';
const STANDARD_VIEW_ROUTE = '/dashboard/standard';
const STANDARD_EDITOR_ROUTE = '/dashboard/create-operating-standard';
const STANDARD_VIEW_PAGE_KEY = 'lastPage';
const PERSONAL_SOURCE = 'personal';
const MANAGEMENT_SOURCE = 'management';
const FIRST_PAGE = 1;

export function readStandardViewPage(storage: Storage = localStorage): number {
  return Number(storage.getItem(STANDARD_VIEW_PAGE_KEY)) || FIRST_PAGE;
}

export function saveStandardViewPage(page: number, storage: Storage = localStorage): void {
  storage.setItem(STANDARD_VIEW_PAGE_KEY, String(page));
}

export function clearStandardViewPage(storage: Storage = localStorage): void {
  storage.removeItem(STANDARD_VIEW_PAGE_KEY);
}

export function getStandardListRoute(storage: Storage = localStorage, source?: string): string {
  if (source === PERSONAL_SOURCE) { return PERSONAL_STANDARD_LIST_ROUTE; }
  const storedUser = storage.getItem(STANDARD_LIST_USER_KEY);
  const user: User = storedUser ? JSON.parse(storedUser) : null;
  const managementAllowed = user && user.roles && user.roles.indexOf(GROUP_CONSTANTS.ROLE_HEAD) !== ROLE_NOT_FOUND;
  if (!managementAllowed) { return PERSONAL_STANDARD_LIST_ROUTE; }
  if (source === MANAGEMENT_SOURCE) { return STANDARD_LIST_ROUTE; }
  return STANDARD_LIST_ROUTE;
}

export function clearStandardListPageOnLeave(storage: Storage = localStorage): void {
  const nextRoute = storage.getItem(NEXT_ROUTE_KEY);
  if (storage.getItem(PREVIOUS_ROUTE_KEY) === STANDARD_LIST_ROUTE && nextRoute
    && !nextRoute.includes(STANDARD_VIEW_ROUTE) && !nextRoute.includes(STANDARD_EDITOR_ROUTE)) {
    storage.removeItem(STANDARD_LIST_PAGE_KEY);
  }
}

export function clearStandardViewPageOnLeave(storage: Storage = localStorage): void {
  const previous = storage.getItem(PREVIOUS_ROUTE_KEY);
  const next = storage.getItem(NEXT_ROUTE_KEY);
  if (previous && previous.includes(STANDARD_VIEW_ROUTE) && next && !next.includes(STANDARD_EDITOR_ROUTE)) {
    storage.removeItem(STANDARD_VIEW_PAGE_KEY);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/standard-list-navigation.ts